/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const A=1e-5,I=3,N=400,O=0;exports.DEFAULT_ANIMATION_DURATION=N;exports.LABEL_DECIMALS=I;exports.MIN_RATIO=A;exports.NO_ANIMATION=O;
